module.exports = __webpack_public_path__ + "static/media/m2.6757a930.png";